var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutDefault',{attrs:{"title":_vm.$t('global.work-in-progress')}})}
var staticRenderFns = []

export { render, staticRenderFns }